"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createIsComposingHandler = void 0;
/**
 * When an IME is used to input text, events fired will have isComposing set to true. When this is
 * the case, we do not want to allow Enter or Escape to be handled by the onKeyDown handler.
 * Generally though, we shouldn't handle ANY keydown events when isComposing is true so this utility
 * helps us block them when necessary.
 *
 * You should wrap your onKeyDown handlers for document-level key events with this function to
 * ensure they are not called when isComposing is true.
 *
 * For React onKeyDown handlers, please use the `useIsComposingHandler` hook instead. Example:
 *
 * ```
 *   useEffect(() => {
 *       const handleKeyEvent = createIsComposingHandler((e) => {
 *           // Do your stuff here.
 *       });
 *
 *       document.addEventListener("keydown", handleKeyEvent);
 *       return () => {
 *           document.removeEventListener("keydown", handleKeyEvent);
 *       };
 *   }, []);
 * ```
 */
const createIsComposingHandler = handler => {
  return e => {
    if (e.isComposing) {
      return;
    } else {
      handler(e);
    }
  };
};
exports.createIsComposingHandler = createIsComposingHandler;
//# sourceMappingURL=createIsComposingHandler.js.map